module.exports = __webpack_public_path__ + "static/img/rule-icon.75bd1b2f.png";